import { useAdminAuth } from '@siclop/ksadmin-vue'
import { useEmployeeStore } from '../stores'

export interface ResolveCurrentEmployeeOptions {
  /** Sans salarié lié à l'utilisateur connecté, prendre le premier salarié actif (sans date de sortie). */
  fallbackToFirstActive?: boolean
}

/**
 * Salarié de l'utilisateur connecté, lu dans le store des salariés (référentiel chargé au démarrage).
 *
 * Remplace le motif « `employeeStore.filter = { personId, pageSize: 1 }` puis `load()` », qui
 * écrasait le référentiel des salariés par une seule ligne (marquée hydratée) : les vues suivantes
 * lisaient alors une liste tronquée. Ici le store n'est jamais filtré ; `ensureLoaded()` ne coûte
 * aucun appel quand le bootstrap l'a déjà chargé.
 */
export function useCurrentEmployee() {
  const { user: currentUser } = useAdminAuth()
  const employeeStore = useEmployeeStore()

  /** Identifiant du salarié de l'utilisateur connecté, 0 s'il n'y en a pas. */
  async function resolveCurrentEmployeeId(options: ResolveCurrentEmployeeOptions = {}): Promise<number> {
    await employeeStore.ensureLoaded()
    const employees = employeeStore.datas || []

    const personId = currentUser.value?.personId
    if (personId) {
      const own = employees.find(e => e.personId === personId)
      if (own) return own.id
    }

    if (options.fallbackToFirstActive) {
      // Même règle que le filtre serveur ActiveOnly : pas de date de sortie.
      const firstActive = employees.find(e => !e.terminationDate)
      if (firstActive) return firstActive.id
    }

    return 0
  }

  return { resolveCurrentEmployeeId }
}
